import type { MarketView } from "../../types/market";
import "./MarketTable.css";

const HEADERS: Record<MarketView, string[]> = {
  live: ["Item", "Level", "Seller", "Current Bid", "Time left", "Listed"],
  history: ["Item", "Level", "Seller", "Buyer", "Final price", "Outcome", "Concluded"]
};

// Varying widths so it doesn't read as a rigid grid - roughly matches how
// full the real columns tend to be.
const COLUMN_WIDTHS: Record<string, string> = {
  Item: "85%",
  Level: "35%",
  Seller: "55%",
  Buyer: "55%",
  "Current Bid": "70%",
  "Final price": "70%",
  "Time left": "60%",
  Outcome: "60%",
  Listed: "75%",
  Concluded: "75%"
};

const SKELETON_ROWS = 8;

const columnClass = (header: string) =>
  header === "Item" ? "market-col-item" : undefined;

const MarketTableSkeleton = ({ view }: { view: MarketView }) => (
  <div className="market-table-wrap">
    <table className={`market-table market-table--${view}`}>
      <thead>
        <tr>
          {HEADERS[view].map(header => (
            <th key={header} className={columnClass(header)}>
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: SKELETON_ROWS }).map((_, rowIndex) => (
          <tr key={rowIndex}>
            {HEADERS[view].map(header => (
              <td key={header} className={columnClass(header)}>
                <div
                  className="market-skeleton-bar"
                  style={{ width: COLUMN_WIDTHS[header] }}
                />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default MarketTableSkeleton;
